import { getColor, media } from '@startlibs/utils';
import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash/fp';
import styled, { css } from 'styled-components';
import { PurviewFooter } from '../../components/PurviewFooter';
import { PageContainer, SectionHeading } from '../../components/PageLayout';
import { darken, lighten, transparentize } from 'polished';
import { Button, ContextMenu, Dialog, DropdownIcon, Icon, Li, Loading, setNotification, Tooltip } from '@startlibs/components';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { jwtGetFetcher, jwtPostFetcher } from '../../utils/authFetch';
import { getJwt } from '../../hooks/useJwt';
import { usePopupToggle, useToggle, WithLazyResource } from '@startlibs/core';
import { TextInput, ToggleCheckbox } from '@startlibs/form';
import { CUSTOM_FIELDS_TYPES, getIconFromType, getTranslatedDescription, getTranslatedTitles, getTypeLabelFromType, isOriginalForm, originalFormStructure, SELECT, TEXT_AREA } from './intakeUtils';
import { IntlProvider, useIntl } from 'react-intl';
import { AddButton } from '../../components/AddButton';
import { TextInputCustom } from '../../components/customFormsFields/Fields';
import { ConfirmDialog, useConfirmDialogWithProps } from '../../hooks/useConfirmDialog';
import { createPortal } from 'react-dom';
import { TAB_CUSTOM_ID_PREFIX, TAB_TYPE_CUSTOM } from '../../request/forms/utils';
import { lazyLocale } from '../../components/I18NProvider';
import { lazyProviderInfo } from '../../components/WithProvider';
import { ConfigurableLocaleSelector } from '../../components/LocaleSelector';
import { getLanguageInfo } from '../../utils/getInitLocale';
import { ConfirmChangesDialog } from '../steps/PatientStep';

//
// STYLED COMPONENTS
//

export const TextButton = styled.a`
  text-decoration: none;
  color: ${getColor('main')};
  padding: 0.25rem 0.75rem;
  font-weight: 600;
  border-radius: 5px;
  user-select: none;
  position:relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  flex-shrink: 0;
  cursor: pointer;
  background-color: ${props => transparentize(0.9, getColor('main')(props))};
  & ~ & {
    margin-left: 0.75rem;
  }
  :hover {
    background-color: ${props => transparentize(0.85, getColor('main')(props))};
  }
  :active {
    background-color: ${props => transparentize(0.8, getColor('main')(props))};
  }
  ${props => props.focused && css`
    background-color: ${props => transparentize(0.9, getColor('main')(props))};
    color: ${getColor('main')};
  `}
  ${props => props.isLoading && css`
    background-color: ${props => transparentize(0.9, getColor('main')(props))};
    color: ${getColor('main')};
    pointer-events: none;
  `}
  ${props => props.started && css`
    background-color: ${props => lighten(0.4, props.theme.colors.success)};
    color: ${getColor('success')};
    pointer-events: none;
  `}
  ${props => props.disabled && css`
    color: ${getColor('gray90')};
    pointer-events: none;
  `}
  ${Loading} {
    display: inline-block;
    margin-right: 4px;
    vertical-align: sub;
  }
  ${Icon} {
    font-size: 18px;
    margin-right: 4px;
    vertical-align: bottom;
    padding: 8px;
  }
  ${DropdownIcon} {
    font-size: 10px;
    margin-left: 0.25rem;
    margin-right: 0;
    transform: translateY(1px);
    vertical-align: baseline;
  }
`

const DropdownButton = styled(TextButton)`
  padding: 0.25rem;
  width: 2rem;
  text-align: center;
  ${props => props.disabledstyle && css`
    color: ${getColor('gray90')};
    opacity: 0.5;
  `}
  ${TextButton} ~ & {
    margin-left: 0.75rem;
  }
  ${DropdownIcon} {
    font-size: 12px;
    margin-left: 0;
    right: 6px;
    top: 6px;
  }
  position: absolute;
  padding: 4px;
`
const ToggleCheckboxSmallNoText = styled(ToggleCheckbox)`
  margin: 0px;
  min-width: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  padding-right: 24px;
  background-color: transparent; 
  height: 32px; 
  min-height: 32px;
  position: absolute;
  right: 36px;
  top: 5px; 
  padding: 16px 12px;

  :hover {
    background-color: transparent;
  }

`;

                                    
const Card = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  margin-bottom: 2rem;
  & ~ ${SectionHeading} {
    margin-top: 3rem;
  }
  ${media.max(520)`
    padding: 1.5rem;
  `}
`;

const Table = styled.div`
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 1px solid ${getColor('gray210')};
`;

const Row = styled.div`
  z-index: 10;
  position: relative;
  background-color: white;
  cursor: pointer !important;
  &:nth-child(odd) {
    background-color: ${getColor('backgroundRowColor')};
  }
  &:last-child {
    border-bottom: 0px;
  }
  ${props => props.notActive && css`
    background-color: #f0f0f0 !important;
  `};
  border-bottom: 1px solid ${getColor('gray210')};
  padding: 1rem;
  transform 0.3s ease, background-color 0.3s ease;
  
  p {
    margin: 0;
    margin-left: 1rem;
    font-size: 14px;
  }
  .custom{
    color: rgba(0,0,0,0.4);
    font-size: 12px;
    display: flex;
    align-items: center;
    ${Icon }{
      margin-right: 0.25rem;
      font-size: 15px;
    }
    &.warning {
      color: rgba(180,0,0,0.6);
    }
  }
    :hover {
      background-color: ${props => darken(0.03, getColor('backgroundRowColor')(props))} !important;
    }
`;

const DragIcon = styled(Icon)`
  font-size: 12pt;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  color: ${getColor('gray120')};
  cursor: ${(props) => (props.isDragging ? 'grabbing' : 'grab')};
  width: 2rem;
  justify-content: center;
`;

const ActionIcon = styled(Icon)`
  color: rgba(0,0,0,0.35);
  font-size: 18px;
  padding: 0;
  margin: 0;
  margin-left: 0.5rem;
  vertical-align: bottom;
`;

const DisableLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 0.5rem;
  font-size: 13px;
  color: ${getColor('main')};
  cursor: pointer;
  font-weight: bold;
  cursor: pointer;
  outline: 0;
  outline: none;
  :hover {
    color: ${props => darken(0.1, getColor("main")(props))};
    ${props => props.notClickable && 'color: #7d7d7d; cursor: default;'}
  }
  position: absolute;
  right: 6px;
  top: 5px; 
  padding: 8px 6px;
  ${props => props.move && 'right: 8rem;'}
  ${props => props.notClickable && 'color: #7d7d7d; cursor: default;'}
`;

// A flex container that wraps items and uses a gap.
const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;  
`;

// A container for each draggable field. If fullWidth is true, the field spans the full width;
// otherwise, it takes roughly half (accounting for the gap).
const FieldContainer = styled.div`
  box-sizing: border-box;
  flex: ${props => props.fullWidth ? '1 1 100%' : '1 1 calc(50% - 0.5rem)'};
`;

const DialogTitleWithLangSelector = styled.div`    
  display: flex;
  align-items: center;
  justify-content: space-between;
  h2 {
    margin: 0;
  }
`;

const WarningMessage = styled.div`
  padding: 1rem 3.5rem 1rem 1rem;
  border-radius: 8px;
  position: relative;
  text-align: left;
  font-size: 13px;
  line-height: 130%;
  background: #c3282d;
  color: white;
  border: 0px;
  margin-bottom: 0.5rem;

  button {
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
  }
  
`;

const CloseWarningIcon = styled(Icon)`
  :hover {
    background: rgba(0, 0, 0, 0.25);
  }
  color: white;
  background-color: rgba(0, 0, 0, 0.2);
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 14px;
  z-index: 2;

`;

export const IntakeFormsConfigPage = () => {
  const providerInfo = lazyProviderInfo.read();
  const defaultLanguage = providerInfo?.preferredLanguage?.defaultLanguage

  const [pageLanguage, setPageLanguage] = useState(defaultLanguage)

  return <WithLazyResource fallback={null} value={lazyLocale.use(pageLanguage)} >{([,messages]) =>
    <IntlProvider messages={messages} locale={pageLanguage} defaultLocale="en-US">
      <IntakeForms pageLanguage={pageLanguage} setPageLanguage={setPageLanguage}/>
    </IntlProvider>
  }</WithLazyResource>

}
  
//
// THE COMPONENT
//
export const IntakeForms = ({ pageLanguage, setPageLanguage}) => {
  const intl = useIntl();

  useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [forms, setForms] = useState([]);
  const [originalForm, setOriginalForm] = useState(null);
  const selectedForm = useToggle();
  const confirmExitDialogToggle = useToggle();
  const [editingItem, setEditingItem] = useState(null);
  const addFieldMenu = usePopupToggle();

  const [tabLanguage, setTabLanguage] = useState(pageLanguage)
  const [validationErrors, setValidationErrors] = useState([]);

  const contextMenu = usePopupToggle();
  
  const [justDragged, setJustDragged] = useState(false);
  
  useEffect(() => {
    setTabLanguage(pageLanguage)
  }, [pageLanguage])

  useEffect(() => {
    if(!selectedForm.isOpen){
      setPageLanguage(tabLanguage)
    }
    
  }, [selectedForm.isOpen])

  const providerInfo = lazyProviderInfo.read();
  const isMultiLanguage = providerInfo?.preferredLanguage?.options?.length > 1
  const defaultLanguage = providerInfo?.preferredLanguage?.defaultLanguage
  const getTranslation = (item, selectedForm, tabLanguage) => {
   
    const translation = selectedForm?.translations?.find(t => t.language === tabLanguage);
    
    if (translation && translation[item] !== undefined && translation[item] !== null) {
      return translation[item];
    }
  
    // fallback: return the value for the default language
    return selectedForm[item] || '';
  };

  /**
   * Utility function to generate a new, unique id for a form field or section.
   */
  const newItemId = (type = '') => {
    const timeId = Date.now().toString(36);
    const randomLetter = String.fromCharCode(Math.floor(Math.random() * 26) + 65);
    return `${type ? type : ''}${timeId}${randomLetter}`;  
  };

  // ============================
  // FIELD ADDITION & REMOVAL
  // ============================
  const addFieldToForm = (selectedForm, type) => {
    const updatedLines = [...selectedForm.isOpen.lines];
    const newField = {
      type: type,
      name: getTypeLabelFromType(type),
      description: '',
      required: false,
      id: newItemId(),
      options: ['','','']
    };

    if(isMultiLanguage){
      newField.translations = []
        newField.translations.push({
          language: defaultLanguage,
          name: getTypeLabelFromType(type),
          description: '',
          options: ['','','']
        })
    }

  
    if (type === TEXT_AREA) {
      // TEXT_AREA occupies a full row (always on left)
      updatedLines.push({ left: newField });
    } else {
      const lastLine = updatedLines[updatedLines.length - 1];
  
      if (!lastLine || (lastLine.left && lastLine.right) || lastLine.left?.type === TEXT_AREA) {
        // Create a new line with left field if none exists, or if the last line is full or is a TEXT_AREA row.
        updatedLines.push({ left: newField });
      } else if (!lastLine.left) {
        lastLine.left = newField;
      } else if (!lastLine.right) {
        lastLine.right = newField;
      }
    }
  
    setEditingItem(newField);
    selectedForm.openWith({ ...selectedForm.isOpen, lines: updatedLines });
  };

  const getUpdatedLines = (lines, fieldId, updatedField) => {
    return lines.map(line => {
      if (line.left && line.left.id === fieldId) {
        return { ...line, left: { ...line.left, ...updatedField } };
      }
      if (line.right && line.right.id === fieldId) {
        return { ...line, right: { ...line.right, ...updatedField } };
      }
      return line;
    });
  };
  const updateFieldInForm = (selectedForm, fieldId, updatedField) => {
    const updatedLines = getUpdatedLines(selectedForm.isOpen.lines, fieldId, updatedField);
    selectedForm.openWith({
      ...selectedForm.isOpen,
      lines: updatedLines
    });
  };

  const removeFieldFromForm = (selectedForm, fieldId) => {
    let updatedLines = selectedForm.isOpen.lines
      .map(line => {
        if (line.left && line.left.id === fieldId) {
          return line.right ? { left: line.right, right: null } : null;
        }
        if (line.right && line.right.id === fieldId) {
          return { ...line, right: null };
        }
        return line;
      })
      .filter(line => line !== null);
  
    selectedForm.openWith({ ...selectedForm.isOpen, lines: updatedLines });
  };

  // ============================
  // HELPERS FOR DRAG & DROP OF FIELDS
  // ============================
  // Flatten the lines into a single array of fields.
  const flattenFields = (lines) => {
    return lines.reduce((acc, line) => {
      if (line.left) acc.push(line.left);
      if (line.right) acc.push(line.right);
      return acc;
    }, []);
  };

  // Reorder a list (helper for drag & drop)
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Re-chunk the flat list of fields into lines according to these rules:
  //  • TEXT_AREA (or a field being edited) must be alone (full width)
  //  • Otherwise, try to put two fields in one line.
  const chunkFields = (flatFields) => {
    const lines = [];
    let i = 0;
    while (i < flatFields.length) {
      const field = flatFields[i];
      if (
        field.type === TEXT_AREA ||
        (editingItem && editingItem.id === field.id)
      ) {
        lines.push({ left: field });
        i++;
      } else {
        if (i + 1 < flatFields.length) {
          const nextField = flatFields[i + 1];
          if (
            nextField.type === TEXT_AREA ||
            (editingItem && editingItem.id === nextField.id)
          ) {
            lines.push({ left: field });
            i++;
          } else {
            lines.push({ left: field, right: nextField });
            i += 2;
          }
        } else {
          lines.push({ left: field });
          i++;
        }
      }
    }
    return lines;
  };

  const chunkFieldsSwapped = (flatFields) => {
    const lines = [];
    let i = 0;
    while (i < flatFields.length) {
      const field = flatFields[i];
      if (field.type === TEXT_AREA || (editingItem && editingItem.id === field.id)) {
        lines.push({ left: field });
        i++;
      } else {
        if (i + 1 < flatFields.length) {
          const nextField = flatFields[i + 1];
          if (nextField.type === TEXT_AREA || (editingItem && editingItem.id === nextField.id)) {
            lines.push({ left: field });
            i++;
          } else {
            // **Swap**: assign the second field to left and the first to right.
            lines.push({ left: nextField, right: field });
            i += 2;
          }
        } else {
          lines.push({ left: field });
          i++;
        }
      }
    }
    return lines;
  };

  // Called when a field drag operation ends.
  const onFieldDragEnd = (result) => {
    if (!result.destination) return;
    const flatFields = flattenFields(selectedForm.isOpen.lines);
    const reorderedFlat = reorder(flatFields, result.source.index, result.destination.index);
    // const newLines = chunkFieldsSwapped(reorderedFlat);
    const newLines = chunkFields(reorderedFlat);
    selectedForm.openWith({ ...selectedForm.isOpen, lines: newLines });
  };

  // ============================
  // TAB DRAG & DROP (unchanged)
  // ============================
  const onDragEnd = (result) => {
    if (!result.destination) return;
    setJustDragged(true); // block clicks briefly
    const reorderedForms = Array.from(forms);
    const [movedItem] = reorderedForms.splice(result.source.index, 1);
    reorderedForms.splice(result.destination.index, 0, movedItem);
    setForms(reorderedForms);
    jwtPostFetcher(getJwt())("/api/intakeFormTemplates", {
      ...originalForm,
      intakeForm: { tabs: reorderedForms }
    }, { method: 'PUT' })
      .then((_res) => null)
      .catch((err) => console.log(err));
    // setJustDragged(true); // block clicks briefly
    setTimeout(() => setJustDragged(false), 500); // adjust as needed
  };

  // ============================
  // FETCH INITIAL DATA
  // ============================
  useEffect(() => {
    jwtGetFetcher(getJwt())("/api/intakeFormTemplates/default")
      .then((res) => {
        setOriginalForm(res);
        const intakeforms = res?.intakeForm?.tabs;
        // Adding translations to the default language for each tab
        setForms(intakeforms.map((tab) => {
          const withTranslation = {
            ...tab,
            translations: tab.translations?.length > 0 ? tab.translations : [{ language: defaultLanguage, name: tab.name, description: tab.description }]
          }
          return withTranslation
        }))
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // ============================
  // CONFIRM DIALOG (for enabling/disabling/deleting a tab)
  // ============================
  const confirmActionTab = useConfirmDialogWithProps(({ action, form, originalForm, forms, setForms }) =>
    <ConfirmDialog
      title={action + " tab"}
      values={{ forms }}
      action={(forms) => {
        jwtPostFetcher(getJwt())("/api/intakeFormTemplates", {
          ...originalForm,
          intakeForm: {
            tabs: forms?.forms.map((tab) => {
              if (tab.id === form.id) {
                return action === 'Enable' ? { ...tab, active: true } : { ...tab, active: false };
              }
              return tab;
            }).filter(tab => action === 'Delete' ? tab.id !== form.id : true),
            language: 'en-US'
          }

        },
        { method: 'PUT' })
          .then((res) => {
            setForms(res?.intakeForm?.tabs);
          })
          .catch((err) => console.log(err));
      }}
      onSuccess={(_values, _response) => {
        
      }}
      confirm={
        <Button 
          success={action === 'Enable'}
          highlight={action === 'Disable'}
          alert={action === 'Delete'}
        >
          {action} tab
        </Button>
      }
      notify={`Tab ${action.toLowerCase()}d successfully`}
    >
        <p>Are you sure you want to {action.toLowerCase()} this tab?</p>
        {form && <p><b>{form.name}</b></p>}
        {/* {action === 'Delete' && <p>Once deleted, it will no longer appear on the form and this action cannot be undone.</p>}
        {action === 'Disable' && <p>It will not appear on the form, but can be enabled again later.</p>}
        {action === 'Enable' && <p>It will now appear on the form.</p>} */}
        {action === 'Delete' && (
            <>
              <p>This tab will be permanently removed and won&apos;t appear on the intake form anymore.</p>
              <p><strong>This action cannot be undone.</strong></p>
            </>
          )}
          {action === 'Disable' && (
            <>
              <p>This tab will be hidden from the intake form but can be enabled again later.</p>
            </>
          )}
          {action === 'Enable' && (
            <>
              <p>This tab will appear on the intake form for patients and admins.</p>
            </>
          )}
      
    </ConfirmDialog>
  );

  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    const div = document.createElement('div');
    div.id = 'drag-drop-portal';
    document.body.appendChild(div);
    setPortalContainer(div);

    return () => {
      document.body.removeChild(div);
    };
  }, []);
      
  // ============================
  // FORM VALIDATION
  // ============================
  const validateForm = (form) => {
    const errors = [];
    const allFields = flattenFields(form.lines);

    allFields.forEach(field => {
      if (field.type === SELECT) {
        // Rule: A dropdown must have at least one non-empty option.
        
        // 1. Validate the default language options.
        // It must have the `options` property, and it must contain at least one non-empty string.
        const defaultOptions = field.options || [];
        const defaultHasOptions = defaultOptions.some(opt => opt && opt.trim() !== '');

        if (!defaultHasOptions) {
          if(isMultiLanguage){
            // errors.push(`Dropdown "${field.name}": At least one option is required for the default language.`);
          }else{
            errors.push(`Dropdown "${field.name}": At least one option is required.`);
          }
        }

        if(isMultiLanguage){
          // 2. Validate options for each translation, if they exist.
          if (field.translations && Array.isArray(field.translations)) {
            field.translations.forEach(translation => {
              const caption = getLanguageInfo(translation.language,providerInfo)?.caption || translation.language;
              // Each translation must also have at least one non-empty option.
              const translatedOptions = translation.options || [];
              const translationHasOptions = translatedOptions.some(opt => opt && opt.trim() !== '');
              
              if (!translationHasOptions) {
                errors.push(`Dropdown "${field.name}": At least one option is required for the '${caption}' translation.`);
              }
            });
          }
        }
      }
    });

    setValidationErrors(errors);
    return errors.length === 0;
  };

  const removeValidationError = (index) => {
    setValidationErrors(errors => errors.filter((_, i) => i !== index));
  };


  // ============================
  // RENDER
  // ============================

  const hasUnsavedChanges = () => {
    const current = selectedForm.isOpen;
    const original = selectedForm.isOpen.originalSnapshot;
    if (!original) return false;

    // Compare without the snapshot itself
    const { originalSnapshot, ...currentClean } = current;
    return !_.isEqual(original, currentClean);
  };

  return (
    <>
      <PageContainer css="max-width: 100%;">
        <Card style={{position: 'relative'}}>
          <h3>Intake form settings</h3>
          <p>Customize the intake experience for new cases. Add custom tabs and fields, and rearrange tabs to set your preferred order.</p>
          <div style={{position: 'absolute', top: '2.5rem', right: '1rem'}}>
            <ConfigurableLocaleSelector providerInfo={providerInfo} locale={pageLanguage} changeLanguage={setPageLanguage} />
          </div>
          <hr />
          {isLoading ? (
            <Loading size={40} style={{ margin: "4rem auto" }} />
          ) : (
            <>
              <Table>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="formsList">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {forms.map((form, index) => <>
                          <Draggable key={form.id} draggableId={form.id} index={index}>
                            {(provided, _snapshot) => (
                              <Row
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                notActive={!form.active}
                                onClick={() => {
                                  if (justDragged) return; // prevent issues
                                  if(isOriginalForm(form.type)) {
                                    selectedForm.openWith(form);
                                  }else{
                                    const { originalSnapshot, ...cleanForm } = form;
                                    selectedForm.openWith({
                                      ..._.cloneDeep(cleanForm),
                                      originalSnapshot: _.cloneDeep(cleanForm)
                                    });
                                  }
                                }}
                              >
                                <DragIcon icon="draggable-vertical" />
                                <p>
                                  {isOriginalForm(form.type) 
                                    ? getTranslatedTitles(form.id, intl)
                                    : isMultiLanguage ? form.translations?.find(t => t.language === pageLanguage) ? form.translations?.find(t => t.language === pageLanguage).name : form.name : form.name
                                  }
                                  {!isOriginalForm(form.type) && (
                                    <Tooltip content="Edit tab structure"><ActionIcon icon="edit" onClick={() => { 
                                      // selectedForm.openWith(form); 
                                      if (justDragged) return; // prevent issues
                                      selectedForm.openWith({...form, originalSnapshot: _.cloneDeep(form)}); 
                                    }} /></Tooltip>
                                  )}
                                </p>
                                {form?.type === TAB_TYPE_CUSTOM && 
                                  <p className="custom">{form?.lines?.length > 0 
                                    ? 'Custom fields' 
                                    : <Tooltip content="This tab has no fields and will not appear in the intake form">
                                      <div className="custom warning">
                                        <Icon icon="failure"/> No fields added
                                      </div>
                                      </Tooltip>
                                  }</p>
                                }
                                {!form?.canDisable && (
                                  <DisableLink notClickable={true} title="This tab cannot be disabled or removed"
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation();
                                    }}
                                  >
                                    Not editable <Icon icon="lock" style={{fontSize: '16px'}}/> 
                                  </DisableLink>
                                )}
                                {/* {form?.canDisable && (
                                  <DisableLink move={!isOriginalForm(form.type) && !form?.active} onClick={(e) => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    confirmActionTab.openWith({ action: form?.active ? 'Disable' : 'Enable', form, originalForm, forms, setForms })
                                  }}>
                                    {form?.active ?  
                                      form?.type === TAB_TYPE_CUSTOM 
                                        ? <Tooltip content="Disable this tab before removing it">Disable tab</Tooltip> 
                                        : "Disable tab"
                                      : "Enable tab"
                                    }
                                  </DisableLink>
                                )} */}
                                {form?.canDisable && (
                                  <ToggleCheckboxSmallNoText
                                    raw
                                    value={ form?.active}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      confirmActionTab.openWith({ action: form?.active ? 'Disable' : 'Enable', form, originalForm, forms, setForms })
                                    }}
                                    disabled={justDragged || !form?.canDisable}
                                    setValue={() => {
                                      confirmActionTab.openWith({ action: form?.active ? 'Disable' : 'Enable', form, originalForm, forms, setForms })
                                    }}
                                  />
                                )}
                                
                                {form?.canDisable && <div style={{ position: 'absolute', right: '30px', top: '-4px'}}>
                                  <Tooltip content={form?.type !== TAB_TYPE_CUSTOM ? "Default tabs cannot be removed" : ""}>
                                    <DropdownButton 
                                      // disabled={form?.type !== TAB_TYPE_CUSTOM}
                                      disabledstyle={form?.type !== TAB_TYPE_CUSTOM}
                                      onClick={(e) => { 
                                        e.preventDefault(); 
                                        e.stopPropagation();
                                        if(form?.type !== TAB_TYPE_CUSTOM) return;
                                        if(contextMenu.isOpen && contextMenu.isOpen === form.id) {
                                          contextMenu.close();
                                        } else {
                                          contextMenu.openWith(form.id)
                                        }
                                      }}>
                                        <DropdownIcon icon="arrow-down"/>
                                    </DropdownButton>
                                  </Tooltip>
                                </div>}
                                
                                 {contextMenu.isOpen && contextMenu.isOpen === form.id && (
                                      <ContextMenu my="top right" at="center right"
                                    >
                                        {
                                          <Li
                                            icon='delete'
                                            label={`Remove tab`}
                                            disabled={!form?.canDisable || form?.active}
                                            onClick={(e) => {
                                              contextMenu.close()
                                              e.preventDefault()
                                              e.stopPropagation()
                                              confirmActionTab.openWith({ action: 'Delete', form, originalForm, forms, setForms })
                                            }}

                                          />
                                        }
                                      </ContextMenu>
                                    )}
                                {/* {form?.type === TAB_TYPE_CUSTOM && !form?.active && (
                                  <DisableLink
                                    notClickable={form?.active} 
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      confirmActionTab.openWith({ action: 'Delete', form, originalForm, forms, setForms })
                                    }}
                                  >
                                    Remove tab
                                  </DisableLink>                                  
                                )} */}
                              </Row>
                            )}
                          </Draggable>
                          
                        </>)}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
              <Button
                small
                highlight
                onClick={() => {
                  const newForm = {
                    id: newItemId(TAB_CUSTOM_ID_PREFIX),
                    name: 'Custom tab',
                    description: '',
                    lines: [],
                    type: TAB_TYPE_CUSTOM,
                    active: true,
                    canDisable: true,
                    isNew: true,
                  }
                  selectedForm.openWith({...newForm, originalSnapshot: _.cloneDeep(newForm)}); 
                }}
              >
                Add tab
              </Button>
            </>
          )}
        </Card>
        {selectedForm.isOpen && <>
          <Dialog
            closeDialog={() => {
              if(!isOriginalForm(selectedForm.isOpen.type)){
                 if (hasUnsavedChanges()) {
                  confirmExitDialogToggle.openWith(true);
                } else {
                  selectedForm.close();
                  setValidationErrors([]);
                }
              }else{
                selectedForm.close()
              }
            }}
            title={
              <DialogTitleWithLangSelector>{
                isOriginalForm(selectedForm.isOpen.type)
                  ? <h2>View tab</h2>
                  : selectedForm.isOpen.isNew
                    ? <h2>Add tab</h2>
                    : <h2>Edit tab</h2>
                }
                {isOriginalForm(selectedForm.isOpen.type) 
                  ? <ConfigurableLocaleSelector small providerInfo={providerInfo} locale={tabLanguage} css="margin-top: -22px; margin-right: 0.25rem !important;" changeLanguage={(e) => {
                    // Upon changing the language on a default form, the form is closed and re-opened with the new language
                    // This requires a delay to allow the allow the app to reload the react intl translated messages and to ensure the tab will work correctly.
                    const localSelectedForm = selectedForm.isOpen
                    selectedForm.close()
                    setTimeout(() => 
                      setPageLanguage(e)
                    , 100)
                    setTimeout(() => 
                      selectedForm.openWith(localSelectedForm)    
                    , 200)
                    setTimeout(() => 
                      setTabLanguage(e)    
                    , 300)
                    
                    }} />
                  : <ConfigurableLocaleSelector small providerInfo={providerInfo} locale={tabLanguage} changeLanguage={setTabLanguage} css="margin-top: -22px; margin-right: 0.25rem !important;"/>
                }                
              </DialogTitleWithLangSelector>
            }
            footer={
              <>
                {validationErrors.map((error, index) => (
                  <WarningMessage key={index}>
                    <span>{error}</span>
                    <CloseWarningIcon icon="x" onClick={() => removeValidationError(index)} />
                  </WarningMessage>
                ))}
                <Button onClick={() => {
                  if(!isOriginalForm(selectedForm.isOpen.type)){
                    if (hasUnsavedChanges()) {
                      confirmExitDialogToggle.openWith(true);
                    } else {
                      selectedForm.close();
                      setValidationErrors([]);
                    }
                  }else{
                    selectedForm.close()
                  }
                }}>Cancel</Button>
                <Button
                  highlight
                  disabled={isOriginalForm(selectedForm.isOpen.type)}
                  isLoading={isSubmitting}
                  onClick={() => {
                    if (validateForm(selectedForm.isOpen)) {
                      setIsSubmitting(true);
                      const updateOrAddTab = (forms, selectedForm) =>
                        _.flow(
                          _.map(tab => tab.id === selectedForm.isOpen.id ? selectedForm.isOpen : tab),
                          forms => selectedForm.isOpen.isNew ? [...forms, selectedForm.isOpen] : forms,
                          _.uniqBy('id')
                        )(forms);
    
                      const newForms = updateOrAddTab(forms, selectedForm);
                      
                      jwtPostFetcher(getJwt())("/api/intakeFormTemplates", {
                        ...originalForm,
                        intakeForm: { tabs: newForms, language: 'en-US' }
                      }, { method: 'PUT' })
                        .then((_res) => {
                          setForms(newForms);
                          setIsSubmitting(false);
                          selectedForm.close();
                          setValidationErrors([]); // Clear errors on successful save
                        })
                        .catch((err) => {
                          console.log(err);
                          setIsSubmitting(false);
                          setNotification({ type: "alert", msg: "Could not save tab" });
                        });
                    }
                  }}
                >
                  Save
                </Button>
              </>
            }
          >
            <TextInput
              disabled={isOriginalForm(selectedForm.isOpen.type)}
              label="Tab title"
              raw
              value={isOriginalForm(selectedForm.isOpen.type) ? getTranslatedTitles(selectedForm.isOpen?.id, intl) : getTranslation('name', selectedForm.isOpen, tabLanguage)}
              setValue={(v) => {
                const currentTranslations = selectedForm.isOpen.translations || [];
                const updatedTranslations = currentTranslations.some(t => t.language === tabLanguage)
                  ? currentTranslations.map(t =>
                      t.language === tabLanguage ? { ...t, name: v } : t
                    )
                  : [...currentTranslations, { language: tabLanguage, name: v, description: selectedForm.isOpen.description }];
            
                selectedForm.openWith({
                  ...selectedForm.isOpen,
                  name: tabLanguage === defaultLanguage ? v : selectedForm.isOpen.name,
                  translations: updatedTranslations,
                });
              }}
            />
            <TextInput
              disabled={isOriginalForm(selectedForm.isOpen.type)}
              label="Tab description"
              helpText="(optional)"
              raw
              value={isOriginalForm(selectedForm.isOpen.type) ? getTranslatedDescription(selectedForm.isOpen?.id, intl) : getTranslation('description', selectedForm.isOpen, tabLanguage)}
              setValue={(v) => {
                const currentTranslations = selectedForm.isOpen.translations || [];
                const updatedTranslations = currentTranslations.some(t => t.language === tabLanguage)
                  ? currentTranslations.map(t =>
                      t.language === tabLanguage ? { ...t, description: v } : t
                    )
                  : [...currentTranslations, { language: tabLanguage, description: v, name: selectedForm.isOpen.name }];
            
                selectedForm.openWith({
                  ...selectedForm.isOpen,
                  description: tabLanguage === defaultLanguage ? v : selectedForm.isOpen.description,
                  translations: updatedTranslations,
                });
              }}
            />
            <hr />
            <h4 css="margin:1rem 0 0.25rem;"><b>Form fields</b></h4>
            {isOriginalForm(selectedForm.isOpen.type) ? ( <>
              <p>It&apos;s not possible to customize this tab fields</p>
              {originalFormStructure(selectedForm.isOpen.type, intl, providerInfo?.emergencyDisclaimer, isMultiLanguage)}
              </>
            ) : (
              <>
                <p>Drag and drop to reorder fields</p>
                {/* --- DRAG & DROP FOR FIELDS --- */}
                {/*
                  We first flatten the current lines into a flat list.
                  Then we render them in a grid.
                  Full-width items (TEXT_AREA or the item being edited) span both columns.
                  When dragging ends, we re-chunk the flat array into lines and update state.
                */}
                {(() => {
                  const flatFields = flattenFields(selectedForm.isOpen.lines);
                  return (
                    <DragDropContext 
                      onDragEnd={onFieldDragEnd}>
                      <Droppable droppableId="formFields">
                        {(provided) => (
                          <FlexContainer ref={provided.innerRef} {...provided.droppableProps}>
                            {flatFields.map((field, index) => (
                              <Draggable key={field.id} draggableId={field.id} index={index}>
                                {(provided, snapshot) => {
                                  const draggableContent = ( <FieldContainer
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    fullWidth={field.type === TEXT_AREA || (editingItem && editingItem.id === field.id)}
                                    style={{
                                      // Spread the default style provided by react-beautiful-dnd:
                                      ...provided.draggableProps.style,
                                      background: snapshot.isDragging ? '#f0f0f0' : 'inherit',
                                      padding: snapshot.isDragging ? '0.5rem' : 'inherit',
                                      borderRadius: snapshot.isDragging ? '0.5rem' : 'inherit',
                                      // // Override opacity to avoid transparency while dragging:
                                      // opacity: 1,
                                      // // Ensure the dragging element appears on top:
                                      // zIndex: snapshot.isDragging ? 1000 : 'auto',
                                      // // Disable pointer events on the dragging clone so that it doesn't interfere:
                                      // pointerEvents: snapshot.isDragging ? 'none' : 'auto'
                                      // // Do not override the transform property as it's needed for positioning.
                                    }}
                                  >
                                    <TextInputCustom
                                      removeFieldFromForm={removeFieldFromForm}
                                      updateFieldInForm={updateFieldInForm}
                                      selectedForm={selectedForm}
                                      editingItem={editingItem}
                                      setEditingItem={setEditingItem}
                                      disabled
                                      item={field}
                                      raw
                                      dragHandleProps={provided.dragHandleProps}
                                      tabLanguage={tabLanguage}
                                      defaultLanguage={defaultLanguage}
                                      fullWidth={field.type === TEXT_AREA || (editingItem && editingItem.id === field.id)}
                                    />
                                  </FieldContainer>)
                                  if (snapshot.isDragging && portalContainer) {
                                    return createPortal(draggableContent, portalContainer);
                                  }
                                  return draggableContent;

                                }}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </FlexContainer>
                        )}
                      </Droppable>
                    </DragDropContext>
                  );
                })()}
                <AddButton onClick={() => addFieldMenu.toggle()} noFocus css="margin-top:1rem;">
                  Add field
                  {addFieldMenu.isOpen && (
                    <ContextMenu my="top center" at="bottom center">
                      {CUSTOM_FIELDS_TYPES.map(type => (
                        <Li
                          key={type}
                          onClick={() => {
                            addFieldToForm(selectedForm, type)
                          }}
                          label={getTypeLabelFromType(type)}
                          icon={getIconFromType(type)}
                        />
                      ))}
                    </ContextMenu>
                  )}
                </AddButton>
              </>
            )}
          </Dialog>
           
          {confirmExitDialogToggle.isOpen && <ConfirmChangesDialog
            title={"Save changes"}
            closeDialog={() => confirmExitDialogToggle.close()}
            closeButton={
              <Button hover="alert" onClick={() => {
                confirmExitDialogToggle.close()
                setEditingItem(null);
                selectedForm.close();
                setValidationErrors([]); // Clear errors on close
              }}>Discard</Button>
            }
            alternativeButton={
              <Button onClick={() => confirmExitDialogToggle.close()}>Continue editing</Button> 
            }
            confirm={
              <Button
                isLoading={isSubmitting}  
                success 
                onClick={() => {
                  if (validateForm(selectedForm.isOpen)) {
                    setIsSubmitting(true);
                    confirmExitDialogToggle.close();
                    const updateOrAddTab = (forms, selectedForm) =>
                      _.flow(
                        _.map(tab => tab.id === selectedForm.isOpen.id ? selectedForm.isOpen : tab),
                        forms => selectedForm.isOpen.isNew ? [...forms, selectedForm.isOpen] : forms,
                        _.uniqBy('id')
                      )(forms);

                    const newForms = updateOrAddTab(forms, selectedForm);
                    
                    jwtPostFetcher(getJwt())("/api/intakeFormTemplates", {
                      ...originalForm,
                      intakeForm: { tabs: newForms, language: 'en-US' }
                    }, { method: 'PUT' })
                      .then((_res) => {
                        setForms(newForms);
                        setIsSubmitting(false);
                        selectedForm.close();
                        setValidationErrors([]); // Clear errors on successful save
                      })
                      .catch((err) => {
                        console.log(err);
                        setIsSubmitting(false);
                        setNotification({ type: "alert", msg: "Could not save tab" });
                      });
                  }  
                }}
              >
                Save
              </Button>
            }
          >
            <p css="max-width: 24rem;">
              <b>{'There are unsaved changes on this page. Would you like to save them?'}</b>
            </p>
          </ConfirmChangesDialog>}
        </>}
      </PageContainer>
      <PurviewFooter />
    </>
  );
};